import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { AngularFireDatabase } from 'angularfire2/database';
import { SpecialsPage } from "../specials/specials";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'page-specialsdashboard',
  templateUrl: 'specialsdashboard.html',
})

export class SpecialsdashboardPage {
  items: any = [];
  uid: string;
  minDate: string = '2000';
  item: any = { specialImage: [], URL: '', name: '', offer: 0, price: 0, availableDays: '', endDate: '', notes: '', startDate: '' };
  path: string = '';
  loaded: boolean = true;
  state: string = 'New';
  specialForm: FormGroup;
  name: AbstractControl;
  offer: AbstractControl;
  price: AbstractControl;
  endDate: AbstractControl;
  notes: AbstractControl;
  startDate: AbstractControl;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public af: AngularFireDatabase,
    public fb: FormBuilder,
    public loadingCtrl: LoadingController) {
    //  let user = JSON.parse(localStorage.getItem('UserId'));
    let userObj = JSON.parse(localStorage.getItem('UserObj'));
    this.uid = userObj.clientId.length == 0 ? '-1' : userObj.clientId;
    //this.item = new special();
    this.items = [];
    this.path = this.navParams.get('path');//'specials/' + userObj.clientId;

    if (typeof this.navParams.get('specialItem') !== 'undefined') {
      this.item = this.navParams.get('specialItem');
      this.state = 'Edit';
      this.items.push(this.item)
      console.log(this.item)
    }

    //if (this.state == 'New') {
    this.specialForm = this.fb.group({
      name: [this.item.name, Validators.compose([Validators.required])],
      endDate: [this.item.endDate],
      startDate: [this.item.startDate],
      price: [this.item.price, Validators.compose([Validators.required, Validators.min(1)])],
      offer: [this.item.offer, Validators.compose([Validators.min(0), Validators.max(100)])],
      notes: [this.item.notes]
    });

    this.name = this.specialForm.controls['name'];
    this.endDate = this.specialForm.controls['endDate'];
    this.startDate = this.specialForm.controls['startDate'];
    this.price = this.specialForm.controls['price'];
    this.offer = this.specialForm.controls['offer'];
    this.notes = this.specialForm.controls['notes'];

    this.loaded = false;


  }

  resetEndDate(special) {
    this.item.endDate = '';
    special.endDate = '';
    this.minDate = special.startDate ? this.item.startDate : 2000;
    console.log('resetEndDate');
  }

  updatedList(event) {
    this.item.URL = event;
    console.log(event);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SpecialsdashboardPage');
  }

  save(special) {
    if (this.specialForm.valid) {
      let loading = this.loadingCtrl.create({
        content: 'Please wait special details are updating.',
        dismissOnPageChange: true
      });

      /*      this.item.name = special.name;
            this.item.endDate = special.endDate;
            this.item.startDate = special.startDate;
            this.item.price = special.price;
            this.item.offer = special.offer;
            this.item.notes = special.notes;
      */
      if (this.item.key) {
        var objToUpdate = this.path + '/' + this.item.key;
        delete this.item.key;
        this.af.object(objToUpdate).update(this.item);
      }
      else
        this.af.list(this.path).push(this.item);
      this.navCtrl.pop()
    }
    else {
      console.error('Not A valid form to update');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/specialsdashboard/specialsdashboard.ts